module.exports = __webpack_public_path__ + "static/media/MOV.84c69f69.svg";